import { breakpoints, css } from '../../styles/theme';
import { rem } from 'polished';

export const StylesOV = css`
    .hasSomeSelected {
        color: ${({ theme }) => theme.colors.black};
        svg {
            path {
                fill: ${({ theme }) => theme.colors.black};
            }
        }
    }

    .options {
        .container {
            &:hover {
                color: ${({ theme }) => theme.colors.black};
            }
        }
        .checkmark {
            border: 1px solid ${({ theme }) => theme.colors.black};
        }
        .container input:checked ~ .checkmark {
            background-color: ${({ theme }) => theme.colors.black};
        }
    }
`;
